export class PontoEletronicoFactory {
  constructor(instance) {
    this.instance = instance;
  }

  importAfd(formData) {
    return this.instance.post('/v1/ponto-eletronico/afd', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  listImportacoes() {
    return this.instance.get('/v1/ponto-eletronico/importacoes');
  }

  getEspelho(params) {
    return this.instance.get('/v1/ponto-eletronico/espelho', { params });
  }

  getResumo(params) {
    return this.instance.get('/v1/ponto-eletronico/resumo', { params });
  }

  exportEspelhoXlsx(params) {
    return this.instance.get('/v1/ponto-eletronico/espelho/exportar-xlsx', {
      params,
      responseType: 'blob',
    });
  }

  completarSaida(payload) {
    return this.instance.post(
      '/v1/ponto-eletronico/espelho/completar-saida',
      payload,
    );
  }

  listAusencias(params) {
    return this.instance.get('/v1/ponto-eletronico/ausencias', { params });
  }

  justificarAusencia(payload) {
    return this.instance.post('/v1/ponto-eletronico/ausencias', payload);
  }

  removerAusencia(id) {
    return this.instance.delete(`/v1/ponto-eletronico/ausencias/${id}`);
  }

  downloadArquivo(id) {
    return this.instance.get(`/v1/ponto-eletronico/importacoes/${id}/arquivo`, {
      responseType: 'blob',
    });
  }
}

export default (...params) => new PontoEletronicoFactory(...params);
